import { DeviceOSEnum } from '@portal/models/enumerators';
import AndroidLogo from '~/assets/logos/android.svg?react';
import AppleLogo from '~/assets/logos/apple.svg?react';
import ChromeLogo from '~/assets/logos/chrome.svg?react';
import FirefoxLogo from '~/assets/logos/firefox.svg?react';
import UnknowLogo from '~/assets/logos/unknow.svg?react';
import EdgeLogo from '~/assets/logos/edge.svg?react';

import PixIcon from '~/assets/icons/pix_icon.png';

export const getLogoBrand = (
  os: DeviceOSEnum | 'android' | 'apple' | 'firefox' | 'chrome' | string
) => {
  switch (os) {
    case DeviceOSEnum.ANDROID:
      return AndroidLogo;
    case DeviceOSEnum.APPLE:
      return AppleLogo;
    case DeviceOSEnum.IOS:
      return AppleLogo;
    case DeviceOSEnum.CHROME:
      return ChromeLogo;
    case DeviceOSEnum.FIREFOX:
      return FirefoxLogo;
    case DeviceOSEnum.EDGE:
      return EdgeLogo;
    default:
      return UnknowLogo;
  }
};

export const getTrasactionIcon = (iconName: string) => {
  const icon = iconName.split('.');

  switch (icon[0]) {
    case 'pix_icon':
      return PixIcon;
    default:
      return null;
  }
};
